export const cultureIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082625/socialbnb/assets/icons/surroundings/Bank.webp';
export const europeIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082581/socialbnb/assets/icons/listingCategoryIcons/europe.webp';
export const asiaIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082575/socialbnb/assets/icons/listingCategoryIcons/asia.webp';
export const southAmericaIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082587/socialbnb/assets/icons/listingCategoryIcons/southamerica.webp';
export const animalsIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082580/socialbnb/assets/icons/listingCategoryIcons/elephant.webp';
export const elephantIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082574/socialbnb/assets/icons/listingCategoryIcons/animal.webp';
export const activeIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082539/socialbnb/assets/icons/characteristics/Trekking.webp';
export const natureIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082586/socialbnb/assets/icons/listingCategoryIcons/Nature.webp';
export const farmIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082582/socialbnb/assets/icons/listingCategoryIcons/Farms.webp';
export const educationIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082366/socialbnb/assets/categories/education.webp';
export const environmentIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082367/socialbnb/assets/categories/environment.webp';
export const equalityIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082367/socialbnb/assets/categories/equality.webp';
export const healthIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082368/socialbnb/assets/categories/health.webp';
export const sportsIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082369/socialbnb/assets/categories/sports.webp';
export const adventureIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082571/socialbnb/assets/icons/listingCategoryIcons/adventure.webp';
export const beachIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082577/socialbnb/assets/icons/listingCategoryIcons/Beach.webp';
export const breakfastIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082578/socialbnb/assets/icons/listingCategoryIcons/Breakfast.webp';
export const campIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082578/socialbnb/assets/icons/listingCategoryIcons/camping.webp';
export const cookingIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082584/socialbnb/assets/icons/listingCategoryIcons/Kitchen.webp';
export const handCraftIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082574/socialbnb/assets/icons/listingCategoryIcons/Arts_Hand_Craft.webp';
export const backPackIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082576/socialbnb/assets/icons/listingCategoryIcons/Backpack.webp';
export const tinyHouseIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082588/socialbnb/assets/icons/listingCategoryIcons/Tiny_House.webp';
export const familyIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082581/socialbnb/assets/icons/listingCategoryIcons/Family.webp';
export const amazingviewsIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082573/socialbnb/assets/icons/listingCategoryIcons/amazingViews.webp';
export const countrySideIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082579/socialbnb/assets/icons/listingCategoryIcons/countrySide.webp';
export const islandsIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082583/socialbnb/assets/icons/listingCategoryIcons/islands.webp';
export const lakeIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082585/socialbnb/assets/icons/listingCategoryIcons/lake.webp';
export const affordableIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082572/socialbnb/assets/icons/listingCategoryIcons/affordable.webp';
export const remoteIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082586/socialbnb/assets/icons/listingCategoryIcons/remote.webp';
export const colombiaIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082780/socialbnb/assets/impactAccomodationsPics/icons/colombia.webp';
export const ecuadorIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082781/socialbnb/assets/impactAccomodationsPics/icons/ecuador.webp';
export const indonesiaIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082782/socialbnb/assets/impactAccomodationsPics/icons/indonesia.webp';
export const italyIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082783/socialbnb/assets/impactAccomodationsPics/icons/italy.webp';
export const spainIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082784/socialbnb/assets/impactAccomodationsPics/icons/spain.webp';
export const namibiaIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082783/socialbnb/assets/impactAccomodationsPics/icons/namibia.webp';
export const starIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082474/socialbnb/assets/Experiencehighlights/activity.png';
